import React from "react";
import { TERMS_OF_USE_CURRENT_VERSION } from "../config/common";
import { isObject } from "@pheaa/channels-component-library";
import store from "../store";

export const isRegistrationRequired = (profileData = store.getState().profile.data) => {
	return (isObject(profileData) && isObject(profileData.registration) && !profileData.registration.isRegistered);
};

export const isTermsOfUseAgreementRequired = (profileData = store.getState().profile.data) => {
	return isObject(profileData) && (!isObject(profileData.termsOfUse) || (isObject(profileData.termsOfUse) && profileData.termsOfUse.agreementVersion !== TERMS_OF_USE_CURRENT_VERSION));
};

export const getWrappedEmailAddress = emailAddress => {
	const emailParts = emailAddress.split("@");
	let returnElem = emailAddress;

	if (emailParts.length === 2) {
		returnElem = (
			<React.Fragment>
				<span>{emailParts[0]}</span>
				<span style={{ whiteSpace: "nowrap" }}>@{emailParts[1]}</span>
			</React.Fragment>
		);
	}

	return returnElem;
};